import React from "react";
import "./ModelViewerComponent.scss";
import arIcon from "../../../assets/ar/ar-icon.png";


const ModelViewerComponent = ({ models }) => {
  const switchSrc = (element, model) => {
    const modelViewer = document.querySelector("model-viewer");
    modelViewer.src = model.modelSrc;
    modelViewer.poster = model.coverImage;
    const slides = document.querySelectorAll(".ar-slide");
    slides.forEach((el) => el.classList.remove("selected"));
    element.classList.add("selected");
  };

  return (
    <div>
      <model-viewer
        src={models[0]?.modelSrc}
        poster={models[0]?.coverImage}
        shadow-intensity="1"
        ar
        camera-controls
        touch-action="pan-y"
        alt="A 3D model carousel"
        style={{
          width: "100%",
          height: "85vh",
          background: "black",
          position: "relative",
        }}
      >
        <button
          className="ar-button"
          slot="ar-button"
        >
          <img src={arIcon}/>
        </button>

        {models.length > 1 && ( 
          <div className="ar-slider">
            <div className="ar-slides">
              {models.map((model) => (
                <button
                  key={model.id}
                  className={`ar-slide ${model.id === "1" ? "selected" : ""}`}
                  onClick={(e) => switchSrc(e.currentTarget, model)}
                  style={{
                    backgroundImage: `url('${model.coverImage}')`,
                  }}
                ></button>
              ))}
            </div>
          </div>
      )}
      </model-viewer>
    </div>
  );
};

export default ModelViewerComponent;